<template>
  <div class="card">
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true">
    </loading>
    <div class="card-body">
      <div v-if="error">
        {{ error }}
      </div>
      <h5 class="card-title text-muted">
        <strong> {{ $t("orders.list") }}</strong>
      </h5>
      <hr />
      <div class="row">
        <div v-show="displayOrderPdf" id="viewOrder">
          <button width="100%" class="btn-dark" @click="hideOrderPdf()" />
          <embed
            id="generatePdfOrder"
            class="pdfInvoice"
            :src="orderSrc"
            width="100%"
            height="600px"
          />
        </div>
        <div class="col-sm-6 col-12">
          <validation-observer ref="v-observer-sales">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="filterOrdersBegin">{{
                  $t("customer.filterBegin")
                }}</label>
              </div>
              <validation-provider v-slot="v" slim rules="required">
                <input
                  id="filterOrdersBegin"
                  v-model="filterOrdersBegin"
                  type="date"
                  name="filterOrdersBegin"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                />
              </validation-provider>
              <validation-provider v-slot="v" slim rules="required">
                <input
                  id="filterOrdersEnd"
                  v-model="filterOrdersEnd"
                  type="date"
                  name="filterOrdersEnd"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                />
              </validation-provider>
              <validation-provider v-slot="v" slim rules="required">
                <select
                  id="filterOrdersState"
                  v-model="filterOrdersState"
                  class="form-control"
                  @onchange="filterOrdersList"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                >
                  <option value="1">{{ $t("orders.all") }}</option>
                  <option value="2">{{ $t("orders.open") }}</option>
                  <option value="4">
                    {{ $t("orders.pending") }}
                  </option>
                  <option value="3">{{ $t("orders.closed") }}</option>
                </select>
              </validation-provider>
              <button class="btn btn-secondary" @click="filterOrdersList">
                {{ $t("buttons.filter") }}
              </button>
            </div>
          </validation-observer>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-striped p-2">
          <thead>
            <tr>
              <th scope="col">
                {{ $t("orders.orderNumber") }}
              </th>
              <th scope="col">
                {{ $t("orders.createAt") }}
              </th>
              <th scope="col">
                {{ $t("customer.company") }}
              </th>
              <th scope="col">
                {{ $t("customer.shippingAddress") }}
              </th>
              <th scope="col">
                {{ $t("orders.grandTotal") }}
              </th>
              <th scope="col">
                {{ $t("orders.currency") }}
              </th>
              <th scope="col">
                {{ $t("orders.status") }}
              </th>
              <th scope="col">
                {{ $t("customer.serviceman") }}
              </th>
              <th scope="col">
                {{ $t("orders.trackingNumber") }}
              </th>
              <th scope="col">
                {{ $t("orders.carrierStatus") }}
              </th>
              <th scope="col">
                {{ $t("orders.logisticsData") }}
              </th>
              <th scope="col">
                {{ $t("orders.referenceNumber") }}
              </th>
            </tr>
          </thead>
          <div>
            <!--            {{ customerOrders.items }}-->
          </div>
          <tbody>
            <tr
              v-for="o in ordersReports"
              :key="o.increment_id"
              class="m-1 p-1 bg-light"
            >
              <td class="">
                <h6 style="cursor: pointer" @click="showOrderInfo(o)">
                  {{ o.docNum }}
                </h6>
              </td>
              <td class="">
                <h6>{{ o.docDate }}</h6>
              </td>
              <td class="">
                <h6>{{ o.debt }}</h6>
              </td>
              <td>
                {{ o.docDueDate }}
              </td>
              <td>
                <span class="badge badge-pill badge-primary float-left">
                  {{ o.net }}
                </span>
              </td>
              <td>{{ o.currency }}</td>
              <td>{{ o.status }}</td>
              <td>{{ o.overdue }}</td>
              <td>
                <a
                  v-if="
                    o.docEntryDocument == 'FEDEX' || o.docEntryDocument == 'UPS'
                  "
                  :href="generateLinkByCarrier(o)"
                  target="_blank"
                  rel="noreferrer"
                >
                  {{ o.creditLimit }}
                </a>
                <span v-else>{{ o.creditLimit }}</span>
              </td>
              <td>
                {{ getStatusCarrier(o.saldoServices) }} :
                {{ o.docEntryDocument }}
              </td>
              <td style="font-size:12px;">
                <p>  {{ $t("orders.weight") }} - {{ parseFloat(o.additional1) }}</p>
                <p>
                  [{{ o.additional2 }} x {{ o.additional3 }} x {{ o.additional4 }}]
                </p>
                <p>
                 {{ $t("orders.cost") }} -  {{ parseFloat(o.additional5) }}
                </p>
              </td>
              <td>{{ o.saldoCommodity }}</td>

              <td colspan="3" class="text-center">
                <button :value="o.docEntry" @click="getOrderPdf(o)">PDF</button>
              </td>
            </tr>
          </tbody>
        </table>
        <!--                <page-controls />-->
      </div>
    </div>
    <comment-order-modal
      :visible="isCommentVisible"
      :order="showedOrder"
      @on-close="isCommentVisible = !isCommentVisible"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getOrders } from "../services/orders";
import store from "../store";
import * as ServiceReport from "../services/reports";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { currencyMixin } from "../mixins";
import CommentOrderModal from "./CommentOrderModal.vue";
import { StatusCarrier } from "../enums/ReportDictionary";

export default {
  name: "OrdersList",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loading,
    CommentOrderModal,
  },
  mixins: [currencyMixin],
  filters: {
    currency(value) {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    },
  },
  data: function() {
    return {
      carrierList: StatusCarrier,
      orders: [],
      ordersReports: [],
      error: null,
      isLoading: false,
      filterOrdersBegin: "",
      filterOrdersEnd: "",
      filterOrdersState: "",
      displayOrderPdf: false,
      orderSrc: "",
      isCommentVisible: false,
      showedOrder: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("cart", ["language"]),
  },
  async created() {
    // await this.getOrders();
    this.filterOrdersBegin = new Date(
      new Date().setDate(new Date().getDate() - 30)
    )
      .toISOString()
      .slice(0, 10);
    this.filterOrdersEnd = new Date().toISOString().slice(0, 10);
    this.filterOrdersState = "1";
  },
  methods: {
    getStatusCarrier: function(e) {
      var result = this.carrierList.find((item) => item.value === e);
      return result ? result.name : "-";
    },
    generateLinkByCarrier(o) {
      let nr = o.creditLimit;
      let urlTrack = "#";
      switch (o.docEntryDocument) {
        case "UPS":
          urlTrack = `https://www.ups.com/track?loc=pl_PL&requester=QUIC&tracknum=${nr}`;
          break;
        case "FEDEX":
          if (o.balance == "PL")
            urlTrack = `https://www.fedex.com/pl-pl/online/domestic-tracking.html#/preview?packages=${nr}&trackingKey=${nr}`;
          else urlTrack = `https://www.fedex.com/fedextrack/?trknbr=${nr}`;
          break;
        default:
          urlTrack;
          break;
      }
      return urlTrack;
    },
    filterOrdersList: function(e) {
      this.$refs["v-observer-sales"].validate().then(async (result) => {
        if (result) {
          this.isLoading = true;
          let response = await ServiceReport.getOrderListByCustomer(
            this.filterOrdersState,
            this.filterOrdersBegin,
            this.filterOrdersEnd,
            this.user.ownerCode
          );
          this.isLoading = false;
          if (response.data) {
            this.ordersReports = response.data.reportFormSubmit.allReports;
          } else {
            console.log(response);
          }
        }
      });
    },
    async getOrders() {
      let serviceMan = store.state.auth.user.serviceman;
      const response = await getOrders(serviceMan);
      this.customerOrders = response.data.customerPlacedOrder.allOrderRecords
        ? response.data.customerPlacedOrder.allOrderRecords.reverse()
        : null;
    },
    async getOrderPdf(order) {
      this.isLoading = true;
      let response = await ServiceReport.getOrderPdf(order, this.language);
      this.isLoading = false;
      if (response.data) {
        var base64 = response.data.reportFormSubmit.allReports;
        let pdfWindow = window.open("about:blank");
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(base64[0].message) +
            "'></iframe>"
        );
      } else {
        console.log(response);
      }
    },
    showOrderInfo(o) {
      this.showedOrder = o;
      this.isCommentVisible = true;
    },
  },
  mounted() {
    this.filterOrdersList();
  },
};
</script>
